var _defs, _path, _g, _path2, _g2, _path3, _g3, _path4, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircalindManaging(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 283.46 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient-2);}.cls-2,.cls-3{fill:#a1c74a;}.cls-2,.cls-4,.cls-5,.cls-6,.cls-7,.cls-8{fill-rule:evenodd;}.cls-9,.cls-4{fill:#4993c1;}.cls-10{mask:url(#mask-2);}.cls-5{fill:#79b638;}.cls-6,.cls-11{fill:#175583;}.cls-12{mask:url(#mask-1);}.cls-7{fill:#1a4a6f;}.cls-13{mask:url(#mask);}.cls-14{fill:url(#linear-gradient-3);}.cls-15,.cls-8{fill:#70bde5;}.cls-16{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -878.89,
    y1: -357.11,
    x2: -841.77,
    y2: -270.69,
    gradientTransform: "translate(473.47 -717.69) rotate(-90)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 125.57,
    y: 114.87,
    width: 58.01,
    height: 59.84,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 129.28,
    y: 120.71,
    width: 50.57,
    height: 48.15,
    transform: "translate(-20.4 264.12) rotate(-77.42)"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -10.99,
    y1: 129.89,
    x2: 35.62,
    y2: 238.44,
    gradientTransform: "translate(174.44 -82.04) rotate(8.82)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-1",
    x: 119.75,
    y: 59.79,
    width: 73.85,
    height: 70.83,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "119.75 121.51 184.02 130.62 193.6 68.91 129.32 59.79 119.75 121.51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: -497.21,
    y1: 327.66,
    x2: -460.47,
    y2: 413.23,
    gradientTransform: "translate(-254.28 -351.27) rotate(-90)",
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    x: 85.46,
    y: 105.1,
    width: 51.51,
    height: 49.19,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 86.18,
    y: 105.86,
    width: 50.07,
    height: 47.67,
    transform: "translate(-3.93 3.48) rotate(-1.76)"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M160.83,129.56c-6.27-4.49-12.53-8.98-18.8-13.48-2.58,7.27-5.15,14.53-7.73,21.8-2.58,7.27-5.15,14.53-7.73,21.8,3.06-.96,6.11-1.92,9.17-2.88,15.77,28.98,38.21,1.2,38.21,1.2-1.05-3.9-2.5-7.93-3.74-11.8-.09-.04-.17-.09-.26-.13,3.22-1.01,6.45-2.02,9.67-3.04-6.27-4.49-12.53-8.98-18.8-13.48"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M160.83,129.56c-6.27-4.49-12.53-8.98-18.8-13.48-2.58,7.27-5.15,14.53-7.73,21.8-2.58,7.27-5.15,14.53-7.73,21.8,3.06-.96,6.11-1.92,9.17-2.88,15.77,28.98,38.21,1.2,38.21,1.2-1.05-3.9-2.5-7.93-3.74-11.8-.09-.04-.17-.09-.26-.13,3.22-1.01,6.45-2.02,9.67-3.04-6.27-4.49-12.53-8.98-18.8-13.48"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M152.6,112.72c8.09,5.03,16.17,10.06,24.26,15.09,2.59-9.16,5.17-18.33,7.76-27.49,2.59-9.16,5.17-18.33,7.76-27.49-3.69,1.43-8.71,7.46-11.07,4.29-14.98-20.14-51.23-7.44-51.23-7.44,1.62,4.72,7.77,18.63,9.61,23.29,.11,.05,.22,.1,.33,.15-3.89,1.51-7.78,3.02-11.68,4.52,8.09,5.03,16.17,10.06,24.26,15.09"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M152.6,112.72c8.09,5.03,16.17,10.06,24.26,15.09,2.59-9.16,5.17-18.33,7.76-27.49,2.59-9.16,5.17-18.33,7.76-27.49-3.69,1.43-8.71,7.46-11.07,4.29-14.98-20.14-51.23-7.44-51.23-7.44,1.62,4.72,7.77,18.63,9.61,23.29,.11,.05,.22,.1,.33,.15-3.89,1.51-7.78,3.02-11.68,4.52,8.09,5.03,16.17,10.06,24.26,15.09"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M127.35,131.97c2.77-7.11,5.55-14.22,8.32-21.34-7.6-.69-15.2-1.38-22.81-2.07-7.6-.69-15.2-1.38-22.81-2.07,1.67,2.7,6.66,5.39,5.01,8.09-17.73,28.94,8.22,36.95,8.22,36.95,3.48-1.97,7-4.34,10.4-6.48,.02-.09,.04-.19,.07-.28,1.76,2.84,3.52,5.69,5.28,8.53,2.77-7.11,5.55-14.22,8.32-21.34"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M127.35,131.97c2.77-7.11,5.55-14.22,8.32-21.34-7.6-.69-15.2-1.38-22.81-2.07-7.6-.69-15.2-1.38-22.81-2.07,1.67,2.7,6.66,5.39,5.01,8.09-17.73,28.94,8.22,36.95,8.22,36.95,3.48-1.97,7-4.34,10.4-6.48,.02-.09,.04-.19,.07-.28,1.76,2.84,3.52,5.69,5.28,8.53,2.77-7.11,5.55-14.22,8.32-21.34"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M157.92,137.51h0s0,0,0,0Zm0,0h0Zm0,0h.01s-.01,0-.01,0h0Zm0-.03v.03h0v-.03Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M147.13,56.05c6.15,1.77,17.17,6.49,24.04,11.33,5.26,3.71,10.72,10.1,10.72,10.1-2.97-1.35-13.91-4.06-21.56-4.66-17.04-1.34-34.65,1.52-47.27,7.87-28.27,14.25-44.2,46.28-42.29,75.25,2.66,40.36,36.82,81.32,95.86,76.61-60.95,38.47-148.31-17.4-140.55-90.25l-.19-2.67c3.21-58.41,65.58-100.85,121.24-83.59Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M255.28,130.87c26.24,122.91-158.69,151.42-170.44,26.51,0,.07,0,0,0,0-.81-12.71,1.39-21.37,4.21-30.46,2.03-6.55,6.34-13.44,6.34-13.44h0c2.51,36.7,27.49,80.71,64.12,82.14-.53-.02,2.12,.06,2.12,.06,51,1.61,92.59-55.35,71.89-102.23,0,0-.84-1.73,.11-.81,10.42,10.53,17.56,24.05,21.65,38.23Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M241.5,109.74s-.03,2.74-.27,6.05c-.23,3.32-.84,6.5-.84,6.5-4.85,29.71-26.71,49.57-55.19,54.64-10.57,1.88-26.57,1.6-35.9-4.64-8.19-5.48-13.56-15.48-13.56-15.48,4.37,.58,16.78-.08,20.94-.54,13.93-1.55,19.38-3.41,26.93-7.66,26.96-15.18,32.27-52.29,12.62-77.25-10.96-13.92-35.55-26.97-60.69-25.44,43.02-26.5,107.61,13.71,105.95,63.82Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircalindManaging);
export default __webpack_public_path__ + "static/media/circalind_managing.10a409d11ad79ac0c968040fb44b81cc.svg";
export { ForwardRef as ReactComponent };